import React, { useEffect, useState, useCallback } from "react";
import { IoMdSend } from "react-icons/io";
import { FaThumbsDown, FaReply, FaHeart } from "react-icons/fa";
import axios from "axios";
import { useParams } from "react-router-dom";
import BASE_URL from "../../configs/api";
import { toast } from "react-toastify";
import { getProxyUrl } from "../../utils/proxy";

// --- Skeleton và CommentItem Components (Không đổi) ---
const SkeletonComment = () => (
  <li className="flex items-start space-x-4 animate-pulse">
    <div className="w-10 h-10 rounded-full bg-gray-700 flex-shrink-0" />
    <div className="flex-grow space-y-2">
      <div className="h-3 w-1/3 bg-gray-700 rounded" />
      <div className="h-3 w-full bg-gray-700 rounded" />
      <div className="h-3 w-4/5 bg-gray-700 rounded" />
    </div>
     {" "}
  </li>
);

const SkeletonUserInfo = () => (
  <div className="flex flex-row gap-3 animate-pulse">
    <div className="flex items-center gap-4 mb-4">
      <div className="w-10 h-10 rounded-full bg-gray-700" />
      <div className="flex flex-col items-start gap-1">
        <div className="h-3 w-16 bg-gray-700 rounded" />
        <div className="h-3 w-24 bg-gray-700 rounded" />
      </div>
    </div>
  </div>
);

const CommentItem = ({
  comment,
  onReplySubmit,
  activeReplyBox,
  setActiveReplyBox,
}) => {
  const [replyContent, setReplyContent] = useState("");
  const [visibleReplies, setVisibleReplies] = useState(2);
  const [showReplies, setShowReplies] = useState(false);

  const handleReply = () => {
    if (!replyContent.trim()) {
      toast.error("Vui lòng nhập nội dung trả lời");
      return;
    }
    onReplySubmit(replyContent, comment.id);
    setReplyContent("");
    setActiveReplyBox(null);
  };

  const showMoreReplies = () => {
    setVisibleReplies((prev) => prev + 5);
  };

  const toggleShowReplies = () => {
    setShowReplies((prev) => !prev);
  };

  return (
    <li className="flex items-start space-x-4">
      <img
        src={getProxyUrl(comment.anh_dai_dien_url) || comment.anh_dai_dien}
        className="w-10 h-10 rounded-full bg-gray-600 flex-shrink-0 mt-0.5 object-cover"
        alt="avatar"
      />
      <div className="flex-grow">
        <div className="flex items-center gap-x-2 mb-1.5">
          <span className="text-sm font-semibold text-gray-100 hover:underline">
            {comment.username}
          </span>
          <span className="ml-3 text-[0.7rem] text-gray-400">
            {comment.thoi_gian}
          </span>
        </div>
        <p className="text-sm text-gray-300 leading-relaxed mb-2">
          {comment.noi_dung}
        </p>
        <div className="flex items-center space-x-5 text-xs text-gray-400">
          <button className="flex items-center space-x-1 hover:text-white group">
            <FaHeart className="w-3.5 h-3.5 group-hover:text-green-500" />
          </button>
          <button className="flex items-center space-x-1 hover:text-white group">
            <FaThumbsDown className="w-3.5 h-3.5 group-hover:text-red-500" />
          </button>
          <button
            onClick={() =>
              setActiveReplyBox(
                activeReplyBox === comment.id ? null : comment.id
              )
            }
            className="flex items-center space-x-1 hover:text-white group"
          >
            <FaReply className="w-3.5 h-3.5 transform scale-x-[-1]" />
            <span>Trả lời</span>
          </button>
        </div>
        {activeReplyBox === comment.id && (
          <div className="mt-4">
            <textarea
              value={replyContent}
              onChange={(e) => setReplyContent(e.target.value)}
              placeholder={`Trả lời ${comment.username}...`}
              className="w-full bg-[#191b28] border border-gray-600 rounded-md p-2 text-sm text-gray-200 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-[#F0B90B] resize-none"
              rows="2"
            />
            <div className="flex justify-end mt-2">
              <button
                onClick={() => setActiveReplyBox(null)}
                className="text-xs text-gray-400 hover:text-white mr-4"
              >
                Hủy
              </button>
              <button
                onClick={handleReply}
                className="flex items-center gap-1 text-white text-xs font-semibold bg-[#ff6f1b] px-3 py-1 rounded-md"
              >
                Gửi <IoMdSend />
              </button>
            </div>
          </div>
        )}
        {comment.replies && comment.replies.length > 0 && (
          <div className="mt-3">
            <button
              onClick={toggleShowReplies}
              className="text-xs font-semibold text-[#F0B90B] hover:text-yellow-300"
            >
              {showReplies
                ? "Ẩn câu trả lời"
                : `Xem ${comment.replies.length} câu trả lời`}
            </button>
          </div>
        )}
        {showReplies && comment.replies && comment.replies.length > 0 && (
          <ul className="space-y-6 mt-4 pl-6 border-l border-gray-700">
            {comment.replies.slice(0, visibleReplies).map((reply) => (
              <CommentItem
                key={reply.id}
                comment={reply}
                onReplySubmit={onReplySubmit}
                activeReplyBox={activeReplyBox}
                setActiveReplyBox={setActiveReplyBox}
              />
            ))}
            {comment.replies.length > visibleReplies && (
              <button
                onClick={showMoreReplies}
                className="text-xs text-[#F0B90B] font-semibold hover:text-yellow-300"
              >
                Xem thêm {comment.replies.length - visibleReplies} câu trả lời
              </button>
            )}
          </ul>
        )}
      </div>
    </li>
  );
};

const CommentsSection = () => {
  const { slug } = useParams();
  const [activeTab, setActiveTab] = useState("binhluan");
  const [loading, setLoading] = useState(false);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [visibleComments, setVisibleComments] = useState(10);
  const [userData, setUserData] = useState({});
  const accessToken = localStorage.getItem("accessToken");
  const isLoggedIn = !!accessToken;
  const [loadingUserData, setLoadingUserData] = useState(true);
  const [activeReplyBox, setActiveReplyBox] = useState(null);

  const fetchComments = useCallback(async () => {
    if (!slug) return;
    try {
      setLoading(true);
      const res = await axios.get(`${BASE_URL}/api/binhluan/`, {
        params: { slug },
      });
      setComments(res.data.results);
    } catch (error) {
      console.error("Lỗi khi lấy bình luận:", error);
    } finally {
      setLoading(false);
    }
  }, [slug]);

  const loadUserProfile = useCallback(async () => {
    if (!accessToken) {
      setLoadingUserData(false);
      return;
    }
    setLoadingUserData(true);
    try {
      const res = await axios.get(`${BASE_URL}/api/auth/profile/`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const data = res.data;
      setUserData({
        username: data.username,
        first_name: data.first_name,
        last_name: data.last_name,
        avatar1: data.anh_dai_dien_url,
        avatar: data.anh_dai_dien,
      });
    } catch (err) {
      console.error("Lỗi khi tải dữ liệu người dùng:", err);
    } finally {
      setLoadingUserData(false);
    }
  }, [accessToken]);

  useEffect(() => {
    fetchComments();
    loadUserProfile();
  }, [slug, fetchComments, loadUserProfile]);

  // --- NEW HELPER FUNCTION: Hàm trợ giúp để thêm một reply vào state ---
  // Hàm này đảm bảo chúng ta không thay đổi state gốc (immutability)
  const addReplyToState = (comments, parentId, newReply) => {
    return comments.map((comment) => {
      if (comment.id === parentId) {
        return {
          ...comment,
          replies: [...(comment.replies || []), newReply],
        };
      }
      if (comment.replies && comment.replies.length > 0) {
        return {
          ...comment,
          replies: addReplyToState(comment.replies, parentId, newReply),
        };
      }
      return comment;
    });
  };

  const handleCommentSubmit = async (content, parentId = null) => {
    if (!accessToken) {
      toast.error("Vui lòng đăng nhập để bình luận");
      return;
    }
    if (!content.trim()) {
      toast.error("Vui lòng nhập nội dung");
      return;
    }

    const toastId = toast.loading("Đang gửi bình luận...");
    try {
      const response = await axios.post(
        `${BASE_URL}/api/binhluan/add/`,
        { slug, noi_dung: content, parent: parentId },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      const newCommentData = response.data;

      if (parentId) {
        const updatedComments = addReplyToState(
          comments,
          parentId,
          newCommentData
        );
        setComments(updatedComments);
      } else {
        setComments((prevComments) => [newCommentData, ...prevComments]);
      }

      setNewComment("");
      toast.update(toastId, {
        render: "Bình luận thành công!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
    } catch (error) {
      toast.update(toastId, {
        render: "Gửi bình luận thất bại",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const handleTabChange = (tab) => {
    if (tab !== activeTab) {
      setLoading(true);
      setTimeout(() => {
        setActiveTab(tab);
        setLoading(false);
      }, 300);
    }
  };

  const loadMoreComments = () => {
    setVisibleComments((prev) => prev + 5);
  };

  return (
    <div id="comments-section" className="mt-8">
      <div className="flex items-center justify-between mb-4">
        <h3 className="flex items-center gap-3 text-base font-semibold text-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              fillRule="evenodd"
              d="M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-4.172a1 1 0 0 0-.707.293l-1.867 1.867C11.054 22.361 9 21.51 9 19.812A.81.81 0 0 0 8.188 19H5a3 3 0 0 1-3-3zm5 0a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z"
              clipRule="evenodd"
            />
          </svg>
            {activeTab === "binhluan" ? "Bình luận" : "Đánh giá"}
          <span className="text-gray-400">({comments.length})</span>
        </h3>
        <div className="flex items-center space-x-2">
          <button
            onClick={() => handleTabChange("binhluan")}
            className={`text-xs px-2.5 py-1 rounded-sm ${
              activeTab === "binhluan"
                ? "bg-white text-black font-semibold"
                : "bg-gray-700 text-gray-200 hover:bg-gray-600"
            }`}
          >
            Bình luận
          </button>
          <button
            onClick={() => handleTabChange("danhgia")}
            className={`text-xs px-2.5 py-1 rounded-sm ${
              activeTab === "danhgia"
                ? "bg-white text-black font-semibold"
                : "bg-gray-700 text-gray-200 hover:bg-gray-600"
            }`}
          >
            Đánh giá
          </button>
        </div>
      </div>
      {isLoggedIn ? (
        loadingUserData ? (
          <SkeletonUserInfo />
        ) : (
          <div className="flex flex-row gap-3">
            <div className="flex items-center gap-4 mb-4">
              <img
                className="w-8 h-8 md:w-10 md:h-10 rounded-full object-cover border-2 border-white"
                src={userData.avatar1 || getProxyUrl(userData.avatar)}
                alt="Avatar người dùng"
              />
              <div className="flex flex-col items-start gap-1">
                <p className="text-sm text-gray-400">Bình luận với tên</p>
                <span className="text-sm text-white font-semibold">
                  {userData?.username}
                </span>
              </div>
            </div>
          </div>
        )
      ) : null}
      <div className="bg-[#ffffff10] p-2 rounded-lg mb-6">
        <textarea
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder={
            activeTab === "binhluan" ? "Viết bình luận..." : "Viết đánh giá..."
          }
          className="w-full h-[120px] bg-[#191b28] border border-transparent rounded-md p-3 pr-16 text-sm text-gray-200 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-[#F0B90B] resize-none min-h-[80px]"
        ></textarea>
        <div className="flex justify-end items-center pb-2 mt-2">
          <button
            onClick={() => handleCommentSubmit(newComment, null)}
            className="flex items-center gap-2 text-white hover:text-orange-300 text-sm font-semibold"
          >
            Gửi <IoMdSend className="h-4 w-4 ml-1" />
          </button>
        </div>
      </div>
      {loading ? (
        <ul className="space-y-8">
          {Array.from({ length: 4 }).map((_, idx) => (
            <SkeletonComment key={idx} />
          ))}
        </ul>
      ) : (
        <>
          {activeTab === "binhluan" && (
            <ul className="space-y-8">
              {comments.slice(0, visibleComments).map((comment) => (
                <CommentItem
                  key={comment.id}
                  comment={comment}
                  onReplySubmit={handleCommentSubmit}
                  activeReplyBox={activeReplyBox}
                  setActiveReplyBox={setActiveReplyBox}
                />
              ))}
            </ul>
          )}
          {comments.length > visibleComments && (
            <div className="mt-10">
              <button
                onClick={loadMoreComments}
                className="text-sm text-[#F0B90B] font-semibold hover:text-yellow-300"
              >
                Xem thêm bình luận
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CommentsSection;
